import React from "react";

const InfoIcon = ({ size = 20, color = "#1C274C", className = "", ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        className={className}
        {...props}
    >
        <path
            d="M12 17V11"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
        />
        <circle cx="12" cy="8" r="1" fill={color} />
        <path
            d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
);

export default InfoIcon;
